import { useAppConfigContext } from '@ltvco/refresh-lib/ctx';
import { IconContainer } from '@ltvco/refresh-lib/v2';
import {
  FingerprintRounded,
  NotificationsRounded,
  ScreenSearchDesktopRounded,
  SecurityRounded,
} from '@mui/icons-material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { constants } from 'appConstants';

import {
  BannerContainer,
  HeaderSection,
  StyledBannerIcon,
  StyledTextContainer,
  StyledHeaderText,
  StyledBodyText,
  StyledButton,
  StyledFeaturesContainer,
  StyledFeatures,
} from './styledComponents';

export const DigitalMonitoringBanner = () => {
  const redirect = useNavigate();
  const { trackEventGA4 } = useAppConfigContext();
  const imgDigitalIdentityLogo = constants?.images?.imgDigitalIdentityLogo;

  const handleBannerClick = () => {
    trackEventGA4({
      event_name: 'navigation_click',
      type: 'Digital Footprint',
      interacted_from: 'rewards',
    });
    redirect('/dashboard/digital-footprint');
  };

  const features: {
    icon: ReactElement;
    description: string;
  }[] = [
    {
      description:
        'Monitor your public data including phone, email, home, and vehicle',
      icon: <NotificationsRounded fontSize="small" sx={{ color: '#0052FF' }} />,
    },
    {
      description: 'Get updates when your data changes',
      icon: <SecurityRounded fontSize="small" sx={{ color: '#0052FF' }} />,
    },
    {
      description: 'Know what is in your public data',
      icon: (
        <ScreenSearchDesktopRounded
          fontSize="small"
          sx={{ color: '#0052FF' }}
        />
      ),
    },
    {
      description: 'See your public data in one place',
      icon: <FingerprintRounded fontSize="small" sx={{ color: '#0052FF' }} />,
    },
  ];

  return (
    <BannerContainer>
      <StyledBannerIcon src={imgDigitalIdentityLogo} alt="digital-identity" />

      <StyledTextContainer>
        <HeaderSection>
          <StyledHeaderText variant="h2">
            Protect Your Digital Footprint
          </StyledHeaderText>
        </HeaderSection>

        <StyledBodyText variant="body1">
          Your digital footprint is composed of data that is publicly available
          on the internet. BeenVerified allows you to monitor this data for
          changes, or when new information becomes available.
        </StyledBodyText>

        <StyledButton variant="contained" onClick={handleBannerClick}>
          Start Monitoring Now
        </StyledButton>
      </StyledTextContainer>

      <StyledFeaturesContainer container>
        {features?.map(({ icon, description }) => (
          <StyledFeatures key={description}>
            <IconContainer icon={icon} />
            <StyledBodyText sx={{ color: 'text.primary' }}>
              {description}
            </StyledBodyText>
          </StyledFeatures>
        ))}
      </StyledFeaturesContainer>
    </BannerContainer>
  );
};

export default DigitalMonitoringBanner;
